var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "transition",
    {
      attrs: {
        "enter-class": "slide-fade-enter",
        "enter-active-class": "slide-fade-enter-active",
      },
    },
    [_vm.showInformationPage ? _vm._t("information") : _vm._t("summary")],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }